/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Type_Chip_LabelInputs */

const en_case_type_chip_label = /** @type {(inputs: Case_Type_Chip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case type`)
};

const pt_br2_case_type_chip_label = /** @type {(inputs: Case_Type_Chip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de caso`)
};

/**
* | output |
* | --- |
* | "Case type" |
*
* @param {Case_Type_Chip_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_type_chip_label = /** @type {((inputs?: Case_Type_Chip_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Type_Chip_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_type_chip_label(inputs)
	return pt_br2_case_type_chip_label(inputs)
});